import type { JSX } from "react";
import { useLocation } from "react-router";
import { useAuth } from "../../features/auth/AuthProvider.js";

const ROUTE_TITLES: Record<string, string> = {
  "/": "Today",
  "/recipes": "Library",
  "/settings/household": "Household",
  "/settings/preferences": "Preferences",
  "/settings/taxonomy": "Taxonomy",
};

function getPageTitle(pathname: string): string {
  return ROUTE_TITLES[pathname] ?? "RecipeVault";
}

interface AppHeaderProps {
  onAvatarClick: () => void;
}

export function AppHeader({ onAvatarClick }: AppHeaderProps): JSX.Element {
  const location = useLocation();
  const { me } = useAuth();

  const displayName = me?.user.displayName ?? "";
  const initials = displayName[0]?.toUpperCase() ?? "?";
  const pageTitle = getPageTitle(location.pathname);

  return (
    <header className="h-14 px-4 flex items-center justify-between border-b border-zinc-800 bg-zinc-900">
      <div className="flex items-center gap-2">
        <img src="/favicon.svg" alt="RecipeVault" className="h-7 w-7" />
        <span className="font-medium text-zinc-100">{pageTitle}</span>
      </div>
      <button
        onClick={onAvatarClick}
        className="w-12 h-12 rounded-full bg-zinc-700 text-zinc-100 text-sm font-medium flex items-center justify-center ring-1 ring-zinc-600 hover:ring-emerald-500/60 min-w-[3rem]"
        aria-label="Open navigation menu"
      >
        {initials}
      </button>
    </header>
  );
}
